/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A skill an identity is authorized to reach.
 */
export type AccessibleSkill = {
  /**
   * Human-readable display name, when set.
   */
  displayName?: string | undefined;
  /**
   * Unique skill identifier.
   */
  id: string;
  /**
   * Internal name of the skill.
   */
  name: string;
  /**
   * Project the skill belongs to.
   */
  projectId: string;
  /**
   * Slug of the project the skill belongs to.
   */
  projectSlug: string;
};

/** @internal */
export const AccessibleSkill$inboundSchema: z.ZodMiniType<
  AccessibleSkill,
  unknown
> = z.pipe(
  z.object({
    display_name: z.optional(z.string()),
    id: z.string(),
    name: z.string(),
    project_id: z.string(),
    project_slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "display_name": "displayName",
      "project_id": "projectId",
      "project_slug": "projectSlug",
    });
  }),
);

export function accessibleSkillFromJSON(
  jsonString: string,
): SafeParseResult<AccessibleSkill, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AccessibleSkill$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AccessibleSkill' from JSON`,
  );
}
